import _ from 'lodash'
import * as query from '@/queries/permissionRole'
import utils from '@/store/utils'
import store from '@/store'
import common from '@/utils/common'

const defaultState = function () {
  return {
    mode: 0,
    tableSetList: [{}],
    tdLists: [],
    totalCount: 0,
    listIndex: -1,
    currentPage: 0,
    size: 10,
    permissionRoleOptions: [],
    isAndSearch: false,
    searchKeyword: '',
    searchKey: 'permission_list',
    searchConditions: {}
  }
}

export default {
  namespaced: true,
  state: defaultState(),
  mutations: {
    update (state, data) {
      const rowData = utils.pick(data, utils.createKeys(query.GRAPH_QL_QUERY_PERMISSION_ROLE_LIST, 1))
      _.forEach(state.tdLists, (val, index) => {
        if (val.uuid === data.uuid) {
          _.merge(state.tdLists[index], _.cloneDeep(rowData))
        }
      })
    },
    delete (state, uuid) {
      _.remove(state.tdLists, (val) => val.uuid === uuid)
    }
  },
  getPermissionRoleOptions: async function (reGet = false) {
    if (store.state.PermissionRole.permissionRoleOptions.length === 0 || reGet) {
      const execQuery = common.addGraphQlCondition(query.GRAPH_QL_QUERY_PERMISSION_ROLE_LIST, { keyword: '' })
      const result = await common.postGraphQl(execQuery)
      Object.keys(result.data.data.permissionRoles).forEach((key) => {
        result.data.data.permissionRoles[key].code = result.data.data.permissionRoles[key].uuid
      })
      store.dispatch({
        type: 'set',
        states: {
          'PermissionRole/permissionRoleOptions': result.data.data.permissionRoles
        }
      })
    }
  },
  getDefaultState: defaultState
}



// WEBPACK FOOTER //
// ./src/store/pages/permissionRole.js